<!--
 * @Description: 下单失败弹窗
 * @Author: wangzhe
 * @Date: 2022-1-13 10:41:00
 * @LastEditors: 牛字杰 niuzijie@.jtexpress
 -->
<template>
  <div  class="fail-order">
    <el-dialog :title="$lang('失败提示')" :visible.sync="dialogTableVisible" :close-on-click-modal="false" :modal-append-to-body='true' width="600px" @opened="dialogOpened">
      <div  class="dialog-center">
        <div class="list" v-for="(item, index) in failList" :key="index">
          <div class="list-t1">{{$lang('客户订单号')}}：<span>{{item.customerOrderId}}</span></div>
        </div>
        <h3 class="reason-title">{{$lang('失败原因')}}：</h3>
        <h4>{{$lang('订单信息不符合下单要求，无法下单')}}</h4>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" class="h40" @click="comfirm" >{{$lang('确认')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'FailOrder',
  data() {
    return {
      dialogTableVisible: false
    }
  },
  props: {
    failList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  methods: {
    comfirm() {
      this.dialogTableVisible = false
    },
    dialogOpened() {
      console.log(this.failList)
    }
  }
}
</script>

<style lang="scss" scoped>
  .fail-order {
    .dialog-center {
      .list {
        display: flex;
        padding-bottom: 5px;
        .list-t1 {
          color: #2b2b2b;
          width: 200px;
          span {
            color: #666666;
          }
        }
      }
      .reason-title {
        color: #2b2b2b;
      }
    }
  }
</style>
